import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'

import type { TeamSchema } from 'teams'

export type DeleteFilter = {
  teamId: string
  tournamentId: string
}

const getInitialState = () =>
  serverResponse<{ excluded: boolean; included: boolean; name: string; team: null | TeamSchema }[]>({
    data: [],
  })

const teamDelete = reduxFetchCreator<'teamsDelete', DeleteFilter, ReturnType<typeof getInitialState>>(
  'teamsDelete',
  getInitialState(),
)

const teamsDeleteEpic = epicRequest({
  actionType: teamDelete.actions.teamsDelete.type,
  errorAction: teamDelete.actions.teamsDeleteError,
  fulfilledAction: teamDelete.actions.teamsDeleteFulfilled,
  // @todo fix type
  overlap: true,
  request: (action: { payload: DeleteFilter }) => ({
    body: action.payload,
    method: 'delete',
    url: `sports/tournament/${action.payload.tournamentId}/team/${action.payload.teamId}`,
  }),
  // @ts-ignore
  untilTypes: teamDelete.actions.teamsDeleteCancel.type,
})

export const actions = {
  ...teamDelete.actions,
}

export const epics = [teamsDeleteEpic]

export const reducer = reducersMerge(teamDelete.reducer) as typeof teamDelete.reducer
